module.exports = __webpack_public_path__ + "img/loader.b5fbc474.png";